import { AvailableUserType } from 'domains/models/event_type/availableUserType';
import { CalendarViewType } from 'domains/models/event_type/calendarViewType';
import { ConfirmationType } from 'domains/models/event_type/confirmationType';
import { DisplayType } from 'domains/models/event_type/displayType';
import { HostAssignType } from 'domains/models/event_type/hostAssignType';
import { PeriodType } from 'domains/models/event_type/periodType';
import { RescheduleType } from 'domains/models/event_type/rescheduleType';
import { EventTypeType } from 'domains/models/event_type/eventTypeType';
import { Status, StatusText } from 'domains/models/event_type/status';
import { CalendarType } from 'domains/models/event_type/calendarType';
import { ReservationMethod } from 'domains/models/event_type/reservationMethod';
import { HostOperationType } from 'domains/models/event_type/hostOperationType';
import { RoundRobinAllocateType } from 'domains/models/event_type/roundRobinAllocateType';
import { ViewerTimeZoneType } from 'domains/models/event_type/viewerTimeZoneType';
import { EventTypeVersion } from 'domains/models/event_type/eventTypeVersion';
import { z } from 'zod';
import {
  LocationType,
  LocationTypeText,
} from 'domains/models/event_type/locationType';
import { AttendType } from 'domains/models/event_type/attendType';

export const StatusTextEnum = z.nativeEnum(StatusText);
export const LocationTypeEnum = z.nativeEnum(LocationType);
export const LocationTypeTextEnum = z.nativeEnum(LocationTypeText);
export const HostAssignTypeEnum = z.nativeEnum(HostAssignType);
export const HostOperationTypeEnum = z.nativeEnum(HostOperationType);
export const DisplayTypeEnum = z.nativeEnum(DisplayType);
export const EventTypeTypeEnum = z.nativeEnum(EventTypeType);
export const ConfirmationTypeEnum = z.nativeEnum(ConfirmationType);
export const CalendarViewTypeEnum = z.nativeEnum(CalendarViewType);
export const AvailableUserTypeEnum = z.nativeEnum(AvailableUserType);
export const RescheduleTypeEnum = z.nativeEnum(RescheduleType);
export const StatusEnum = z.nativeEnum(Status);
export const RoundRobinAllocateTypeEnum = z.nativeEnum(RoundRobinAllocateType);
export const ViewerTimeZoneTypeEnum = z.nativeEnum(ViewerTimeZoneType);
export const EventTypeVersionEnum = z.nativeEnum(EventTypeVersion);
export const ReservationMethodEnum = z.nativeEnum(ReservationMethod);
export const PeriodTypeEnum = z.nativeEnum(PeriodType);
export const CalendarTypeEnum = z.nativeEnum(CalendarType);
export const AttendTypeEnum = z.nativeEnum(AttendType);
